import { render, staticRenderFns } from "./cardViewer.vue?vue&type=template&id=45f6a327&"
import script from "./cardViewer.vue?vue&type=script&lang=js&"
export * from "./cardViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports